/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core';
import {translate} from '@ion/core/src/locale/locale';
import {AdminGroupChooser} from '@ion/features/src/entities/group/AdminGroupChooser';
import {GroupAssignmentAccountChooserProps} from './GroupAssignmentAccountChooser';
import {
  GroupAssignmentDetailsFields,
  GroupAssignmentFormProps
} from './GroupAssignmentDetailsForm';

export interface RemoveGroupAssignmentActionProps extends
  GroupAssignmentAccountChooserProps,
  GroupAssignmentFormProps {}

const useStyles = makeStyles(() => ({
  paddingTop25 : {
    paddingTop    : '25px',
    paddingBottom : '20px'
  }
}));

/**
 * Re-usable hook for removing group.
 */
export const RemoveGroupAssignmentAction = ({
  replaceGroups,
  handleRemoveGroupChooser,
  formState,
  path,
  multiSelect = false,
  areGroupsLoading = false
}: RemoveGroupAssignmentActionProps) => {
  const classes = useStyles();

  return (
    <div className={classes.paddingTop25}>
      <AdminGroupChooser required
        includeNone
        multiSelect={multiSelect}
        fieldLabel={translate(`${path}.group`)}
        noneOptionValue={'removeAllGroup'}
        noneOptionLabel={translate(`${path}.removeAllGroup`)}
        groupOptions={replaceGroups}
        loading={areGroupsLoading}
        onChange={handleRemoveGroupChooser}
        hasError={formState[GroupAssignmentDetailsFields.REMOVE_GROUP]?.error}
        errorText={formState[GroupAssignmentDetailsFields.REMOVE_GROUP]?.error
          ? translate(`${path}.error`)
          : translate(`${path}.groupExistError`)
        }
        defaultValue={formState[GroupAssignmentDetailsFields.REMOVE_GROUP]?.value} />
    </div>
  );
};

export default RemoveGroupAssignmentAction;
